import React, { useEffect, useCallback } from "react";
import {useDispatch, useSelector} from "react-redux";
import { useHistory } from "react-router-dom";

import { provReducerActions, provSagaActions } from "../../Information/Province";
// import { refSagaActions } from "../../Information/Reference";
import { paymentReducerActions } from "../../Payment";

import { Form, Col, Card, Container, Spinner, Row, Button } from "react-bootstrap";
import { Search, ArrowBarLeft } from "react-bootstrap-icons";
import { RegionHeader } from "../components/RegionHeader";
import { ProvinceCatalogueCarousel } from "../components/ProvincesCatalogueCarousel";

import { useSubheader } from "../../../../_metronic/layout";
//import "../css/bootstrap-card-columns.css";

//import cardColStyles from "../css/CardColumn.module.css";

export const ProvinceCatalogue = (props) => {

  const subheader = useSubheader();
  subheader.setTitle("Goverment Services");

  const dispatch = useDispatch();
  const history = useHistory();

  const { 
    province : {entities: provinces, totalCount: provTotalCount, listLoading},
    catalogue: { selectedRegion } 
  } = useSelector((state) => state);
  
  useEffect(() => {
    dispatch(provReducerActions.reset());
    dispatch(provSagaActions.fetchAllProvInRegion({regionId: selectedRegion.id}));
    dispatch(paymentReducerActions.resetState());
  
  }, [dispatch, selectedRegion]);  
  
  const debounceFunction = (func, delay) => {
    
    let timer;
  
    return function() {
      let self = this;
      let args= arguments;
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(self, args)
      }, delay)
    }
  };
  
  //use useCallback to memoized or remeber the original function
  const debounceCatalogueSearch = useCallback(
    debounceFunction(
      (nextValue) => {
        let query = { str: nextValue, regionId: selectedRegion.id };
        if(nextValue){
          dispatch(provSagaActions.searchProvinces(query));
        } else {
          dispatch(provSagaActions.fetchAllProvInRegion({regionId: selectedRegion.id}));
        }
      }, 500
    ), [selectedRegion.id]
  );

  const handleBackNavigation = () => {
    history.push("/catalogue-management/region");
  };  
  
  const handleCatalogueSearch = (event) =>{
    let nextValue = event.target.value;
    debounceCatalogueSearch(nextValue);
  };
  
  return (
    <Card>
      <Card.Header>
        <Row>
          <Col lg={9} sm={12}>
            <RegionHeader regionName={selectedRegion.name} imgBase64={"../media/logos/png-emblem-DOF.png"} />
          </Col>
          <Col lg={3}  sm={12}>
            <Button onClick={handleBackNavigation} style={{float:"right"}} variant="secondary" >
              <ArrowBarLeft size={18} /> {" "} BACK
            </Button>
          </Col>
        </Row>
      </Card.Header>
      <Card.Body>
        <Container fluid>
          <Row>
            <Col>
              <Form.Group controlId="search">
              <Search size={30} className="pt-3 pl-3" style={{ position: "absolute" }}/>
                  <Form.Control
                    className="pl-10"
                    style={{ fontSize: "16px"}}
                    name="search"
                    placeholder="Search for a province"
                    onChange={handleCatalogueSearch}
                  />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              { 
                listLoading 
                ? <Spinner className="listSpinner" animation="border" /> 
                : ( provTotalCount <= 0 ? <h5 className="d-flex justify-content-center">No provinces found</h5>
                  : <ProvinceCatalogueCarousel provinces={provinces} provTotalCount={provTotalCount} /> )
              }
            </Col>
          </Row>
        </Container>
      </Card.Body>
    </Card>
  );
};
